export const apiName: string = 'contatos-areas';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/areas/area-contatos/data.service.ts
 **/